// TODO: check + ensure all locales are not being included/bundled into output
import parseISO from "date-fns/parseISO";

export const getTimezoneOffsetDate = (utcDateString: string) => {
  const date = parseISO(utcDateString);
  const timezoneOffset = date.getTimezoneOffset() * -60000;

  return new Date(date.getTime() + timezoneOffset);
};
